module.exports = __webpack_public_path__ + "img/headPortrait.35014692.png";